import { OrderFilter } from '@/types/orders.type';

export const getDateRangeByFilter = (filter: OrderFilter): { startDate: Date; endDate: Date } => {
  const now = new Date();
  let startDate: Date;
  let endDate: Date = new Date();

  switch (filter) {
    case OrderFilter.TODAY:
      startDate = new Date(now.setHours(0, 0, 0, 0)); // Set to the start of today
      endDate = new Date(now.setHours(23, 59, 59, 999)); // Set to the end of today
      break;
    case OrderFilter.THIS_WEEK:
      startDate = new Date(now.setDate(now.getDate() - 7));
      break;
    case OrderFilter.THIS_MONTH:
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    case OrderFilter.THIS_YEAR:
      startDate = new Date(now.getFullYear(), 0, 1);
      break;
    default:
      startDate = new Date(now.setHours(0, 0, 0, 0));
  }

  return { startDate, endDate };
};
